import { splitJobDescription } from './jobDescriptionItems';

/**
 * A job description as a bulleted list of duties; a description of one duty
 * stays plain text.
 *
 * @param {Object} props
 * @param {string} props.text - The description as stored.
 * @param {string} [props.className]
 */
export default function JobDescriptionList({ text, className = '' }) {
  const items = splitJobDescription(text);
  if (!items.length) return null;
  if (items.length === 1) return <div className={className}>{items[0]}</div>;
  return (
    <ul className={`m-0 list-disc space-y-0.5 pl-5 ${className}`}>
      {items.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  );
}
